export enum DocumentDownloadActionEnum {
  DownloadRaw = 'DownloadRaw',
  Download = 'Download',
  View = 'View',
  TakeTraining = 'TakeTraining',
}
